import { useParams } from '@tanstack/react-router'
import { useRecord } from '@/db/hooks'
import { projectKind, type ProjectResource, type ProjectSpec, type ProjectStatus } from '@/kinds/project'
import { Gone } from './NotFound'

export const ProjectView = () => {
  const { id } = useParams({ strict: false }) as { id: string }
  const project = useRecord<ProjectSpec, ProjectStatus>(id) as ProjectResource | null | undefined
  if (project === undefined) return null
  if (!project || project.deleted_at || project.kind !== 'Project')
    return <Gone kind="project" deleted={!!project?.deleted_at} />
  const Detail = projectKind.Detail
  return <Detail resource={project} />
}
